import React, { useEffect, useState, useCallback } from "react"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { useHistory } from "react-router-dom"
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"
import { Link } from "react-router-dom"
import classnames from "classnames"
import Select from "react-select"
import { URLS } from "../../Url"
import axios from "axios"
import {
  Card,
  CardBody,
  Col,
  Container,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  CardTitle,
  Label,
  Button,
  Form,
  FormGroup,
} from "reactstrap"

const CustomOption = ({
  innerProps,
  label,
  isSelected,
  innerRef,
  selectOption,
  data,
}) => {
  const handleCheckboxChange = e => {
    e.stopPropagation()
    selectOption(data)
  }

  return (
    <div
      {...innerProps}
      ref={innerRef}
      className="d-flex align-items-center p-2"
    >
      <input
        type="checkbox"
        checked={isSelected}
        onChange={handleCheckboxChange}
        className="me-2"
      />
      {label}
    </div>
  )
}

const AddStore = () => {
  const history = useHistory()
  const token = JSON.parse(localStorage.getItem("authUser"))?.token
  const SellerId = sessionStorage.getItem("Sellerid")

  const [activeTab, setActiveTab] = useState(1)
  const [passedSteps, setPassedSteps] = useState([1])
  const [isLoading, setIsLoading] = useState(true)
  const [form, setForm] = useState({
    countryCode: "91",
    storeName: "",
    storePhone: "",
    storeEmail: "",
    countryId: "",
    stateId: "",
    cityId: "",
    gst: "",
    storePincode: "",
    storeAddressOne: "",
    storeAddressTwo: "",
    businessLevel: "",
    bizcategoryId: "",
  })

  const [storeStates, setStoreStates] = useState([])
  const [storeCities, setStoreCities] = useState([])
  const [deliveryCountries, setDeliveryCountries] = useState([])
  const [deliveryStates, setDeliveryStates] = useState([])
  const [deliveryCities, setDeliveryCities] = useState([])
  const [deliveryPincodes, setDeliveryPincodes] = useState([])
  const [availableDeliveryStates, setAvailableDeliveryStates] = useState([])
  const [availableDeliveryCities, setAvailableDeliveryCities] = useState([])
  const [availableDeliveryPincodes, setAvailableDeliveryPincodes] = useState([])
  const [bizzcategories, setbizzcategories] = useState([])

  const [deliveryTypes, setDeliveryTypes] = useState([])
  const [receiptModes, setReceiptModes] = useState([])

  const [files, setFiles] = useState({
    storeProfile: null,
    storeBanner: null,
    gstImage: null,
  })

  const [previews, setPreviews] = useState({
    storeProfile: "https://placehold.co/500x500/png",
    storeBanner: "https://placehold.co/2000x500/png",
    gstImage: "https://placehold.co/500x500/png",
  })

  const [countries, setCountries] = useState([])
  const [deliveryTypeOptions, setDeliveryTypeOptions] = useState([])

  useEffect(() => {
    return () => {
      Object.values(previews).forEach(preview => {
        if (preview.startsWith("blob:")) {
          URL.revokeObjectURL(preview)
        }
      })
    }
  }, [previews])

  const fetchCountries = async () => {
    try {
      const response = await axios.post(
        URLS.GetCountry,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      return response.data.countrys
    } catch (error) {
      throw error
    }
  }

  const fetchDeliveryTypes = async () => {
    try {
      const response = await axios.post(
        URLS.GetAllDeliveryTypes,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      return response.data.deliverytypes
    } catch (error) {
      throw error
    }
  }

  // Updated multi-select API functions
  const fetchMultiStatesByCountries = async countryIds => {
    try {
      const response = await axios.post(
        URLS.GetMultiCountrybyStateId,
        { country_ids: countryIds },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      return response.data.states || []
    } catch (error) {
      console.error("Error fetching multi states:", error)
      toast.error("Failed to fetch states")
      return []
    }
  }

  const fetchMultiCitiesByStates = async stateIds => {
    try {
      const response = await axios.post(
        URLS.GetMultiStatebyDistrictId,
        { state_id: stateIds },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      return response.data.data || []
    } catch (error) {
      console.error("Error fetching multi cities:", error)
      toast.error("Failed to fetch cities")
      return []
    }
  }

  const fetchMultiPincodesByDistricts = async districtIds => {
    try {
      const response = await axios.post(
        URLS.GetMultiDistrictIdbyPincode,
        { district_id: districtIds },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      return response.data.data || []
    } catch (error) {
      console.error("Error fetching multi pincodes:", error)
      toast.error("Failed to fetch pincodes")
      return []
    }
  }

  // Single select functions for store location
  const fetchStoreStates = async countryId => {
    try {
      const response = await axios.post(
        URLS.GetCountrybyStateId,
        { country_id: countryId },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      return response.data.states
    } catch (error) {
      throw error
    }
  }

  const fetchStoreCities = async stateId => {
    try {
      const response = await axios.post(
        URLS.GetStatebyDistrictId,
        { state_id: stateId },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      return response.data.districts
    } catch (error) {
      throw error
    }
  }

  const fetchBizzCategories = useCallback(async () => {
    try {
      const response = await axios.post(
        URLS.GetBizzCategory,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setbizzcategories(response?.data?.bizcategorys || [])
    } catch (error) {
      toast.error("Failed to load BizCategory")
    }
  }, [token])

  useEffect(() => {
    const initializeData = async () => {
      try {
        const [countriesData, deliveryTypesData] = await Promise.all([
          fetchCountries(),
          fetchDeliveryTypes(),
          fetchBizzCategories(),
        ])
        setCountries(countriesData)
        setDeliveryTypeOptions(deliveryTypesData)
        setIsLoading(false)
      } catch (error) {
        console.error("Error initializing data:", error)
        toast.error("Failed to initialize data")
        setIsLoading(false)
      }
    }

    initializeData()
  }, [token, SellerId])

  const receiptOptions = [
    { value: "Pre-Pay", label: "Pre-Pay" },
    { value: "Post-Pay", label: "Post-Pay" },
  ]

  const handleStoreStateChange = async e => {
    const { name, value } = e.target

    if (name === "countryId") {
      setForm(prev => ({
        ...prev,
        countryId: value,
        stateId: "",
        cityId: "",
      }))
      setStoreStates([])
      setStoreCities([])
      if (value) {
        try {
          const response = await fetchStoreStates(value)
          setStoreStates(response)
        } catch (error) {
          toast.error("Failed to fetch states")
        }
      }
    }
  }

  const handleStoreCityChange = async e => {
    const { name, value } = e.target

    if (name === "stateId") {
      setForm(prev => ({
        ...prev,
        stateId: value,
        cityId: "",
      }))
      setStoreCities([])

      if (value) {
        try {
          const response = await fetchStoreCities(value)
          setStoreCities(response)
        } catch (error) {
          toast.error("Failed to fetch cities")
        }
      }
    }
  }

  const handleDeliveryCountryChange = async selectedCountries => {
    setDeliveryCountries(selectedCountries)
    setDeliveryStates([])
    setDeliveryCities([])
    setDeliveryPincodes([])

    if (selectedCountries.length > 0) {
      try {
        const countryIds = selectedCountries.map(country => country.value)
        const statesData = await fetchMultiStatesByCountries(countryIds)
        setAvailableDeliveryStates(statesData)
      } catch (error) {
        toast.error("Failed to fetch delivery states")
      }
    } else {
      setAvailableDeliveryStates([])
      setAvailableDeliveryCities([])
      setAvailableDeliveryPincodes([])
    }
  }

  const handleDeliveryStateChange = async selectedStates => {
    setDeliveryStates(selectedStates)
    setDeliveryCities([])
    setDeliveryPincodes([])

    if (selectedStates.length > 0) {
      try {
        const stateIds = selectedStates.map(state => state.value)
        const citiesData = await fetchMultiCitiesByStates(stateIds)
        setAvailableDeliveryCities(citiesData)
      } catch (error) {
        toast.error("Failed to fetch delivery cities")
      }
    } else {
      setAvailableDeliveryCities([])
      setAvailableDeliveryPincodes([])
    }
  }

  const handleDeliveryCityChange = async selectedCities => {
    setDeliveryCities(selectedCities)
    setDeliveryPincodes([])

    if (selectedCities.length > 0) {
      try {
        const districtIds = selectedCities.map(city => city.value)
        const pincodesData = await fetchMultiPincodesByDistricts(districtIds)
        setAvailableDeliveryPincodes(pincodesData)
      } catch (error) {
        toast.error("Failed to fetch delivery pincodes")
      }
    } else {
      setAvailableDeliveryPincodes([])
    }
  }

  const handleDeliveryPincodeChange = selectedPincodes => {
    setDeliveryPincodes(selectedPincodes)
  }

  const toggleTab = tab => {
    if (activeTab !== tab && tab >= 1 && tab <= 4) {
      setActiveTab(tab)
      setPassedSteps(prev => [...new Set([...prev, tab])])
    }
  }

  const handleFileChange = (e, type) => {
    const file = e.target.files[0]
    if (!file) return

    const ext = file.name.split(".").pop().toLowerCase()
    if (!["jpg", "jpeg", "png"].includes(ext)) {
      e.target.value = null
      return toast.error(
        "File format not supported. Please choose JPG, JPEG, or PNG."
      )
    }

    if (previews[type] && previews[type].startsWith("blob:")) {
      URL.revokeObjectURL(previews[type])
    }

    setFiles(prev => ({ ...prev, [type]: file }))
    setPreviews(prev => ({ ...prev, [type]: URL.createObjectURL(file) }))
  }

  const handleChange = e => {
    const { name, value } = e.target
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async e => {
    e.preventDefault()
    // Validate required fields
    if (
      !form.storeName ||
      !form.storePhone ||
      !form.countryId ||
      !form.stateId ||
      !form.cityId ||
      !form.storePincode
    ) {
      toast.error("Please fill all required fields")
      return
    }

    const formData = new FormData()
    formData.append("countryCode", form.countryCode)
    formData.append("countryId", form.countryId)
    formData.append("gst", form.gst || "")
    formData.append("stateId", form.stateId)
    formData.append("cityId", form.cityId)
    formData.append("storeName", form.storeName)
    formData.append("storePhone", form.countryCode + form.storePhone)
    formData.append("storeEmail", form.storeEmail || "")
    formData.append("storePincode", form.storePincode)
    formData.append("storeAddressOne", form.storeAddressOne || "")
    formData.append("storeAddressTwo", form.storeAddressTwo || "")
    formData.append("businessLevel", form.businessLevel || "")
    formData.append("bizcategoryId", form.bizcategoryId || "")

    // Append arrays only if they have values
    if (deliveryCountries.length > 0) {
      formData.append(
        "deliveryCountryIds",
        JSON.stringify(deliveryCountries.map(c => c.value))
      )
    }
    if (deliveryStates.length > 0) {
      formData.append(
        "deliveryStateIds",
        JSON.stringify(deliveryStates.map(s => s.value))
      )
    }
    if (deliveryCities.length > 0) {
      formData.append(
        "deliveryDistrictIds",
        JSON.stringify(deliveryCities.map(c => c.value))
      )
    }
    if (deliveryPincodes.length > 0) {
      formData.append(
        "deliveryPincodesIds",
        JSON.stringify(deliveryPincodes.map(p => p.value))
      )
    }
    if (deliveryTypes.length > 0) {
      formData.append(
        "deliverTypeIds",
        JSON.stringify(deliveryTypes.map(d => d.value))
      )
    }
    if (receiptModes.length > 0) {
      formData.append(
        "receiptMode",
        JSON.stringify(receiptModes.map(r => r.value))
      )
    }

    Object.entries(files).forEach(([key, file]) => {
      if (file) formData.append(key, file)
    })

    try {
      const response = await axios.post(URLS.AddStore, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })

      if (response.status === 200) {
        toast.success(response.data.message)
        history.push("/ViewSeller")
      }
    } catch (error) {
      console.error("Error updating store:", error)
      toast.error(
        error.response?.data?.message ||
        "An error occurred while updating store"
      )
    }
  }

  if (isLoading) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center my-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </div>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Bizzmate Supplier" breadcrumbItem="Add Store" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Col xl="12">
                    <Button
                      onClick={() => history.goBack()}
                      className="mb-3 "
                      style={{ float: "right" }}
                      color="primary"
                      type="button"
                      outline
                    >
                      <i className="far fa-arrow-alt-circle-left me-1"></i>
                      Back
                    </Button>
                  </Col>
                  <h4 className="card-title mb-4">Add Store</h4>
                  <Form onSubmit={handleSubmit} autoComplete="off">
                    <div
                      className="wizard clearfix"
                      style={{ border: "1px solid #D5F2E9" }}
                    >
                      <div className="steps clearfix">
                        <ul>
                          {[
                            { id: 1, title: "Biz Registration" },
                            { id: 2, title: "Bizz Address" },
                            { id: 3, title: "Biz Locations" },
                            { id: 4, title: "Delivery Type / Receipt Mode" },
                          ].map(step => (
                            <NavItem
                              key={step.id}
                              className={classnames({
                                current: activeTab === step.id,
                              })}
                            >
                              <NavLink
                                className={classnames({
                                  active: activeTab === step.id,
                                })}
                                onClick={() => toggleTab(step.id)}
                                disabled={!passedSteps.includes(step.id)}
                                style={{ cursor: "pointer" }}
                              >
                                <span className="number">{step.id}.</span>
                                {step.title}
                              </NavLink>
                            </NavItem>
                          ))}
                        </ul>
                      </div>
                      <div className="content clearfix">
                        <TabContent activeTab={activeTab} className="body">
                          <TabPane tabId={1}>
                            <CardTitle>Biz Registration</CardTitle>
                            <hr />
                            <Row>
                              <Col md="6">
                                <FormGroup className="mb-3">
                                  <Label>
                                    Store Name
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Store Name"
                                    name="storeName"
                                    value={form.storeName}
                                    onChange={handleChange}
                                    required
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="6">
                                <FormGroup className="mb-3">
                                  <Label>
                                    Store Phone
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <PhoneInput
                                    country={"in"}
                                    value={
                                      form.storePhone
                                        ? `${form.countryCode}${form.storePhone}`
                                        : ""
                                    }
                                    onChange={(phone, country) => {
                                      setForm({
                                        ...form,
                                        countryCode: country.dialCode,
                                        storePhone: phone.replace(
                                          country.dialCode,
                                          ""
                                        ),
                                      })
                                    }}
                                    inputClass="form-control"
                                    dropdownClass="country-dropdown"
                                    placeholder="Store Phone"
                                    enableSearch
                                    required
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="6">
                                <FormGroup className="mb-3">
                                  <Label>Email</Label>
                                  <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter Email"
                                    name="storeEmail"
                                    value={form.storeEmail}
                                    onChange={handleChange}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="6">
                                <FormGroup className="mb-3">
                                  <Label>
                                    Store Category
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <select
                                    name="bizcategoryId"
                                    value={form.bizcategoryId}
                                    onChange={handleChange}
                                    className="form-select"
                                    required
                                  >
                                    <option value="">Select</option>
                                    {bizzcategories.map(data => (
                                      <option key={data._id} value={data._id}>
                                        {data.name}
                                      </option>
                                    ))}
                                  </select>
                                </FormGroup>
                              </Col>
                              <Col md="6">
                                <FormGroup className="mb-3">
                                  <Label>Gst Number</Label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Gst Number"
                                    name="gst"
                                    value={form.gst}
                                    onChange={handleChange}
                                  />
                                </FormGroup>
                              </Col>
                              <Col lg="6">
                                <FormGroup className="mb-3">
                                  <Label>Gst Document</Label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    onChange={e =>
                                      handleFileChange(e, "gstImage")
                                    }
                                  />
                                  {previews.gstImage && (
                                    <img
                                      src={previews.gstImage}
                                      alt="GST Document Preview"
                                      className="mt-2"
                                      style={{
                                        height: "200px",
                                      }}
                                    />
                                  )}
                                </FormGroup>
                              </Col>
                              <Col lg="6">
                                <FormGroup className="mb-3">
                                  <Label>
                                    Store Profile (Ratio 1:1)
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    onChange={e =>
                                      handleFileChange(e, "storeProfile")
                                    }
                                  />
                                  {previews.storeProfile && (
                                    <img
                                      src={previews.storeProfile}
                                      alt="Store Profile Preview"
                                      className="mt-2"
                                      style={{
                                        height: "100px",
                                      }}
                                    />
                                  )}
                                </FormGroup>
                              </Col>
                              <Col lg="6">
                                <FormGroup className="mb-3">
                                  <Label>
                                    Store Banner (Ratio 4:1)
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    onChange={e =>
                                      handleFileChange(e, "storeBanner")
                                    }
                                  />
                                  {previews.storeBanner && (
                                    <img
                                      src={previews.storeBanner}
                                      alt="Store Banner Preview"
                                      className="mt-2"
                                      style={{
                                        maxWidth: "100%",
                                        height: "100px",
                                      }}
                                    />
                                  )}
                                </FormGroup>
                              </Col>
                            </Row>
                          </TabPane>
                          <TabPane tabId={2}>
                            <CardTitle>Bizz Address</CardTitle>
                            <hr />
                            <Row>
                              <Col md="6">
                                <FormGroup className="mb-3">
                                  <Label>
                                    Store Country
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <select
                                    name="countryId"
                                    value={form.countryId}
                                    onChange={handleStoreStateChange}
                                    className="form-select"
                                    required
                                  >
                                    <option value="">Select</option>
                                    {countries.map(data => (
                                      <option key={data.id} value={data.id}>
                                        {data.name}
                                      </option>
                                    ))}
                                  </select>
                                </FormGroup>
                              </Col>
                              <Col md="6">
                                <FormGroup className="mb-3">
                                  <Label>
                                    Store State
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <select
                                    name="stateId"
                                    value={form.stateId}
                                    onChange={handleStoreCityChange}
                                    className="form-select"
                                    disabled={!form.countryId}
                                    required
                                  >
                                    <option value="">Select</option>
                                    {storeStates.map(data => (
                                      <option key={data.id} value={data.id}>
                                        {data.name}
                                      </option>
                                    ))}
                                  </select>
                                </FormGroup>
                              </Col>
                              <Col md="6">
                                <FormGroup className="mb-3">
                                  <Label>
                                    Store district
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <select
                                    name="cityId"
                                    value={form.cityId}
                                    onChange={handleChange}
                                    className="form-select"
                                    disabled={!form.stateId}
                                    required
                                  >
                                    <option value="">Select</option>
                                    {storeCities.map(data => (
                                      <option key={data.id} value={data.id}>
                                        {data.name}
                                      </option>
                                    ))}
                                  </select>
                                </FormGroup>
                              </Col>
                              <Col md="6">
                                <FormGroup className="mb-3">
                                  <Label>
                                    Store Locations
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Store Locations"
                                    name="storePincode"
                                    value={form.storePincode}
                                    onChange={handleChange}
                                    required
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="6">
                                <FormGroup className="mb-3">
                                  <Label>Address 1</Label>
                                  <textarea
                                    className="form-control"
                                    placeholder="Enter Address 1"
                                    rows={1}
                                    name="storeAddressOne"
                                    value={form.storeAddressOne}
                                    onChange={handleChange}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="6">
                                <FormGroup className="mb-3">
                                  <Label>Address 2</Label>
                                  <textarea
                                    className="form-control"
                                    placeholder="Enter Address 2"
                                    rows={1}
                                    name="storeAddressTwo"
                                    value={form.storeAddressTwo}
                                    onChange={handleChange}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </TabPane>
                          <TabPane tabId={3}>
                            <CardTitle>Bizz Locations</CardTitle>
                            <hr />
                            <Row className="d-flex justify-content-center">
                              <Col md="8">
                                <FormGroup className="mb-3">
                                  <Label>Business Level</Label>
                                  <select
                                    name="businessLevel"
                                    value={form.businessLevel}
                                    onChange={handleChange}
                                    className="form-select"
                                  >
                                    <option value="">Select</option>
                                    <option value="Country">Country</option>
                                    <option value="State">State</option>
                                    <option value="District">District</option>
                                    <option value="Pincode">Pincode</option>
                                  </select>
                                </FormGroup>
                              </Col>
                              {(form.businessLevel === "Country" ||
                                form.businessLevel === "State" ||
                                form.businessLevel === "District" ||
                                form.businessLevel === "Pincode") && (
                                  <Col md="8">
                                    <FormGroup className="mb-3">
                                      <Label>Delivery Countries</Label>
                                      <Select
                                        placeholder="Select delivery countries"
                                        options={countries.map(c => ({
                                          value: c.id,
                                          label: c.name,
                                        }))}
                                        value={deliveryCountries}
                                        onChange={handleDeliveryCountryChange}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        components={{
                                          Option: CustomOption,
                                        }}
                                        styles={{
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#f0f0f0"
                                              : "white",
                                            ":active": {
                                              backgroundColor: "#e0e0e0",
                                            },
                                          }),
                                          control: provided => ({
                                            ...provided,
                                            minHeight: "45px",
                                          }),
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>
                                )}
                              {(form.businessLevel === "State" ||
                                form.businessLevel === "District" ||
                                form.businessLevel === "Pincode") && (
                                  <Col md="8">
                                    <FormGroup className="mb-3">
                                      <Label>Delivery States</Label>
                                      <Select
                                        placeholder="Select delivery states"
                                        options={availableDeliveryStates.map(
                                          s => ({
                                            value: s.id,
                                            label: s.name,
                                          })
                                        )}
                                        value={deliveryStates}
                                        onChange={handleDeliveryStateChange}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        isDisabled={!deliveryCountries.length}
                                        components={{
                                          Option: CustomOption,
                                        }}
                                        styles={{
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#f0f0f0"
                                              : "white",
                                            ":active": {
                                              backgroundColor: "#e0e0e0",
                                            },
                                          }),
                                          control: provided => ({
                                            ...provided,
                                            minHeight: "45px",
                                          }),
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>
                                )}
                              {(form.businessLevel === "District" ||
                                form.businessLevel === "Pincode") && (
                                  <Col md="8">
                                    <FormGroup className="mb-3">
                                      <Label>Delivery districts</Label>
                                      <Select
                                        placeholder="Select delivery districts"
                                        options={availableDeliveryCities.map(
                                          c => ({
                                            value: c.id,
                                            label: c.name,
                                          })
                                        )}
                                        value={deliveryCities}
                                        onChange={handleDeliveryCityChange}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        isDisabled={!deliveryStates.length}
                                        components={{
                                          Option: CustomOption,
                                        }}
                                        styles={{
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#f0f0f0"
                                              : "white",
                                            ":active": {
                                              backgroundColor: "#e0e0e0",
                                            },
                                          }),
                                          control: provided => ({
                                            ...provided,
                                            minHeight: "45px",
                                          }),
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>
                                )}
                              {form.businessLevel === "Pincode" && (
                                <Col md="8">
                                  <FormGroup className="mb-3">
                                    <Label>Delivery Pincode</Label>
                                    <Select
                                      placeholder="Select delivery pincode"
                                      options={availableDeliveryPincodes.map(
                                        p => ({
                                          value: p._id,
                                          label: p.pincode,
                                        })
                                      )}
                                      value={deliveryPincodes}
                                      onChange={handleDeliveryPincodeChange}
                                      isMulti
                                      closeMenuOnSelect={false}
                                      hideSelectedOptions={false}
                                      isDisabled={!deliveryCities.length}
                                      components={{
                                        Option: CustomOption,
                                      }}
                                      styles={{
                                        option: (provided, state) => ({
                                          ...provided,
                                          backgroundColor: state.isSelected
                                            ? "#f0f0f0"
                                            : "white",
                                          ":active": {
                                            backgroundColor: "#e0e0e0",
                                          },
                                        }),
                                        control: provided => ({
                                          ...provided,
                                          minHeight: "45px",
                                        }),
                                      }}
                                    />
                                  </FormGroup>
                                </Col>
                              )}
                            </Row>
                          </TabPane>
                          <TabPane tabId={4}>
                            <CardTitle>Delivery Type</CardTitle>
                            <hr />
                            <Row className="d-flex justify-content-center">
                              <Col md="8">
                                <FormGroup className="mb-3">
                                  <Label>Delivery Types</Label>
                                  <Select
                                    placeholder="Select delivery types"
                                    options={deliveryTypeOptions.map(d => ({
                                      value: d._id,
                                      label: d.name,
                                    }))}
                                    value={deliveryTypes}
                                    onChange={selected =>
                                      setDeliveryTypes(selected)
                                    }
                                    isMulti
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    components={{
                                      Option: CustomOption,
                                    }}
                                    styles={{
                                      option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isSelected
                                          ? "#f0f0f0"
                                          : "white",
                                        ":active": {
                                          backgroundColor: "#e0e0e0",
                                        },
                                      }),
                                      control: provided => ({
                                        ...provided,
                                        minHeight: "45px",
                                      }),
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <hr />
                            <CardTitle>Receipt Mode</CardTitle>
                            <hr />
                            <Row className="d-flex justify-content-center">
                              <Col md="8">
                                <FormGroup className="mb-3">
                                  <Label>Receipt Modes</Label>
                                  <Select
                                    placeholder="Select receipt modes"
                                    options={receiptOptions}
                                    value={receiptModes}
                                    onChange={selected =>
                                      setReceiptModes(selected)
                                    }
                                    isMulti
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    components={{
                                      Option: CustomOption,
                                    }}
                                    styles={{
                                      option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isSelected
                                          ? "#f0f0f0"
                                          : "white",
                                        ":active": {
                                          backgroundColor: "#e0e0e0",
                                        },
                                      }),
                                      control: provided => ({
                                        ...provided,
                                        minHeight: "45px",
                                      }),
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </TabPane>
                        </TabContent>
                      </div>
                      <div className="actions clearfix">
                        <ul>
                          <li
                            className={
                              activeTab === 1 ? "previous disabled" : "previous"
                            }
                          >
                            <Link
                              to="#"
                              onClick={() => toggleTab(activeTab - 1)}
                              style={{ cursor: "pointer" }}
                            >
                              Previous
                            </Link>
                          </li>
                          <li
                            className={
                              activeTab === 4 ? "next disabled" : "next"
                            }
                          >
                            <Link
                              to="#"
                              onClick={() => toggleTab(activeTab + 1)}
                              style={{ cursor: "pointer" }}
                            >
                              Next
                            </Link>
                          </li>
                        </ul>
                        {activeTab === 4 && (
                          <div className="d-flex justify-content-end mt-4">
                            <Button
                              type="submit"
                              color="primary"
                              className="py-2 px-5"
                            >
                              Submit
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddStore
